import { render, staticRenderFns } from "./MeetTheTeam.vue?vue&type=template&id=4fb3b20c&scoped=true&"
import script from "./MeetTheTeam.vue?vue&type=script&lang=ts&"
export * from "./MeetTheTeam.vue?vue&type=script&lang=ts&"
import style0 from "./MeetTheTeam.vue?vue&type=style&index=0&id=4fb3b20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3b20c",
  null
  
)

export default component.exports